/**
 * 遷移アニメーションを定義
 */
import gsap from 'gsap';

// 遷移要素
const transitionItem = document.getElementById('transition-item') as HTMLElement;

/**
 * 共通 - Page Out Animation
 */
export const commonPageOut = () => {
  return new Promise<void>(resolve => {
    gsap.fromTo(transitionItem,
      { yPercent: 0, },
      {
        yPercent: -100,
        duration: 0.4,
        ease: 'power4.out',
        onComplete: () => resolve(),
      },
    );
  });
}

/**
 * 共通 - Page In Animation
 */
export const commonPageIn = () => {
  const transitionItem = document.getElementById('transition-item') as HTMLElement;
  return new Promise<void>(resolve => {
    gsap.fromTo(transitionItem,
      { yPercent: -100, },
      {
        yPercent: -200,
        duration: 0.6,
        ease: "power2.out",
        onComplete: () => resolve(),
      },
    );
  });
}